module.exports = __webpack_public_path__ + "img/group-dark.b632498a.png";